<template>
  <dialog
    :class="['modal', { 'modal-open': true }]"
    @cancel.prevent="$emit('close')"
  >
    <div class="modal-box w-[calc(100%-32px)] max-w-md mx-4 sm:mx-auto p-5 sm:p-[28px] rounded-[24px] bg-white shadow-2xl relative border border-[#22ec9b]">
      <!-- Close Button -->
      <button
        type="button"
        class="w-8 h-8 absolute top-4 right-4 flex items-center justify-center rounded-full hover:bg-black/5 transition-colors cursor-pointer border-none bg-transparent"
        @click="$emit('close')"
      >
        <svg
          viewBox="0 0 14 14"
          fill="none"
          class="w-[12px] h-[12px] text-gray-500"
        >
          <path
            d="M1.5 1.5L12.5 12.5M1.5 12.5L12.5 1.5"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <h3 class="text-xl font-['Raleway'] font-bold text-[#043f42] mb-2">
        Clone Cohort
      </h3>
      <p class="text-sm font-['Raleway'] text-gray-600 mb-6">
        Duplicate <strong>{{ cohort.name }}</strong> and its programmes. Enrollments are not copied.
      </p>

      <form @submit.prevent="submitClone">
        <div class="mb-5">
          <label class="block text-sm font-bold text-[#043f42] font-['Raleway'] mb-2">New Cohort Name</label>
          <input
            v-model="newName"
            type="text"
            required
            class="w-full h-11 px-4 border border-gray-300 rounded-[12px] focus:outline-none focus:border-[#01d680] focus:ring-2 focus:ring-[#01d680]/20 font-['Raleway'] text-sm"
          >
        </div>

        <!-- Error Message -->
        <div
          v-if="error"
          class="mb-5 p-3 rounded-[10px] bg-red-50 border border-red-200 text-red-700 text-sm font-['Raleway']"
        >
          {{ error }}
        </div>

        <div class="flex items-center justify-end gap-3 mt-6">
          <button
            type="button"
            class="px-5 py-2.5 rounded-full border border-gray-300 text-gray-700 font-['Raleway'] font-bold text-sm hover:bg-gray-50 transition-colors cursor-pointer bg-white"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="submit"
            :disabled="isSubmitting"
            class="flex items-center justify-center px-5 py-2.5 rounded-full bg-[#01d680] text-[#043f42] font-['Raleway'] font-bold text-sm hover:bg-[#00c270] transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer border-none"
          >
            <span
              v-if="isSubmitting"
              class="w-4 h-4 mr-2 border-2 border-[#043f42] border-t-transparent rounded-full animate-spin"
            />
            {{ isSubmitting ? 'Cloning...' : 'Clone Cohort' }}
          </button>
        </div>
      </form>
    </div>
    <form
      method="dialog"
      class="modal-backdrop bg-[#00000099]"
    >
      <button @click.prevent="$emit('close')">
        close
      </button>
    </form>
  </dialog>
</template>

<script>
export default {
  name: 'CloneCohortModal',
  props: {
    cohort: {
      type: Object,
      required: true
    }
  },
  emits: ['close'],
  data () {
    return {
      newName: `${this.cohort.name.replace(/\s*\(Copy(?:\s+\d+)?\)$/, '')} (Copy)`,
      isSubmitting: false,
      error: null
    }
  },
  mounted () {
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount () {
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    handleKeydown (e) {
      if (e.key === 'Escape') this.$emit('close')
    },
    async submitClone () {
      if (!this.newName.trim()) return

      this.isSubmitting = true
      this.error = null

      try {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        const response = await fetch(`/cohorts/${this.cohort.id}/clone`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: JSON.stringify({ name: this.newName.trim() })
        })

        const data = await response.json()

        if (response.ok) {
          if (window.Turbo) {
            window.Turbo.visit(data.redirect_url)
          } else {
            window.location.assign(data.redirect_url)
          }
        } else {
          this.error = data.error || 'Failed to clone cohort. Please try again.'
          this.isSubmitting = false
        }
      } catch (err) {
        console.error('Failed to clone cohort:', err)
        this.error = 'An unexpected error occurred. Please try again.'
        this.isSubmitting = false
      }
    }
  }
}
</script>
